import SearchTicketsForm from './styles'

export default SearchTicketsForm